module.exports = __webpack_public_path__ + "images/wertentwicklung_neutral_FBB.svg.svg?0ea20ba613551ee1f5b53fba2a747d28";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/wertentwicklung_neutral_FBB.svg.svg
// module id = ziMR
// module chunks = 0